import { i18n } from '@apps/main/modules/localization/localizationSetup';

import type { AppSingleSelectOption } from '@libs/ui';

const { t } = i18n.global;
export function getTicketsAmountOptions(
  min = 0,
  max = 99
): AppSingleSelectOption<number>[] {
  const options = Array.from({ length: max - min + 1 }, (_, i) => {
    const ticketAmountCount = i + min;
    if (ticketAmountCount === 0) {
      return ZERO_OPTION;
    } else {
      return {
        id: ticketAmountCount,
        label: ticketAmountCount.toString(),
      };
    }
  });

  const hasZero = min <= 0;
  const optionsWithZero = hasZero ? options : [ZERO_OPTION, ...options];

  return [SAME_AS_PAXES_OPTION, ...optionsWithZero];
}

export const ZERO_OPTION: AppSingleSelectOption<number> = {
  id: 0,
  label: `${t('planner.no_tickets_selected')}`,
};

export const SAME_AS_PAXES_OPTION = {
  id: -1,
  label: `${t('planner.adjust_tickets_amount')}`,
};
